<div class="ir-item-line th-filter">
  <div class="ir-item-cell size-custom clickable" style="width: 25%">
    <span>
      {{ 'inspections.start-date' | translate }}
    </span>
  </div>
  <div class="ir-item-cell size-custom clickable" style="width: 25%">
    <span>
      {{ 'inspections.installation-type' | translate }}
    </span>
  </div>
  <div class="ir-item-cell size-custom clickable" style="width: 25%">
    <span>
      {{ 'inspections.fst' | translate }}
    </span>
  </div>
  <div class="ir-item-cell size-custom clickable right" style="width: 25%">
    <span>
      {{ 'inspections.progression' | translate }}
    </span>
  </div>
</div>
<div class="ir-content-flow has-filter">
  <div
    class="ir-item-line th-inspection clickable"
    [ngClass]="{
      'offline-not-loaded': inspection?.status === -50,
      'new-inspection': inspection?.isNew
    }"
    (click)="toggleSelectInspection.emit(inspection)"
    *ngFor="let inspection of inspections"
  >
    <div class="ir-item-cell size-custom" style="width: 25%">
      <span>{{ inspection?.startDate | formatDate }}</span>
    </div>
    <div class="ir-item-cell size-custom" style="width: 25%">
      <span>{{
        (inspection?.applicationSubType
          ? 'application.sub-type.' + applicationSubType[inspection.applicationSubType]
          : ''
        ) | translate
      }}</span>
    </div>

    <div class="ir-item-cell size-custom" style="width: 25%">
      <span>{{ inspection?.technicianName }}</span>
    </div>
    <div class="ir-item-cell size-custom right strong statut" style="width: 25%">
      <i *ngIf="inspection.reportItemId" (click)="openReport(inspection, $event)" class="material-icons list-icon"
        >picture_as_pdf</i
      >
      <span>{{ inspection?.progression }} %</span>
    </div>
  </div>

  <div class="ir-item-empty ir-mv8" *ngIf="inspections?.length == 0">
    <p>
      <span>{{ 'inspections.no-inspections' | translate }}</span>
    </p>
  </div>
</div>
